import React from "react";

// import submitIcon from "img/icon-submit-white.svg";

import Button from "components/Button";
import Icon from "components/Icon";

import { Wrapper, Inner, Input, Status, Loader } from "./styles";

const SimpleForm = ({
  placeholder,
  status,
  message,
  size,
  icon,
  onSubmitted,
  ...props
}) => {
  let input;

  const submit = () =>
    input &&
    input.value.indexOf("@") > -1 &&
    onSubmitted({
      EMAIL: input.value
    });

  return (
    <Wrapper onSubmit={event => event.preventDefault()} {...props}>
      <Inner size={size}>
        <Input
          size={size}
          type="email"
          ref={node => (input = node)}
          placeholder={
            placeholder || "Enter email to subscribe to our mailing list"
          }
        />
        {status === "sending" && <Loader mr="2px" size="32px" />}
        <Button
          p={size === "small" ? "8px" : "10px 10px 9px"}
          shade="primary"
          size={size}
          onClick={submit}
          type="submit"
        >
          <Icon icon="send" size={size === "small" ? "14px" : "18px"} />
        </Button>
      </Inner>
      {status === "error" && (
        <Status status={status} dangerouslySetInnerHTML={{ __html: message }} />
      )}
      {status === "success" && (
        <Status status={status} dangerouslySetInnerHTML={{ __html: message }} />
      )}
    </Wrapper>
  );
};

export default SimpleForm;
